module.exports = "/_next/static/images/smm-image-1x-f881454be881e783ac6d2abca5efce65.png.webp";